import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHymnForTheSoul from "../../../../src/content/hymns-for-the-soul/donationHeader";
import "../../../../src/content/hymns-for-the-soul/hymns-soul.scss";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHymnForTheSoul,
  React
};